import { createFileRoute } from "@tanstack/react-router";
import SaintTmsCostGoogle from "@/pages/SaintTmsCostGoogle";
export const Route = createFileRoute("/saint-tms-cost-google")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "SAINT® TMS Cost & Insurance | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SAINT® TMS cost and insurance at Neuro Wellness in Coral Springs, FL. Starting at $25,000 with financing and free benefits verification available.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS Cost & Insurance | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SAINT® TMS cost and insurance at Neuro Wellness in Coral Springs, FL. Starting at $25,000 with financing and free benefits verification available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-tms-cost-google",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-tms-cost-google",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintTmsCostGoogle />;
}
